export default "__VITE_ASSET__V7M_WddN__"